import Api from './Api';
import Configuracao from '../util/Configuracao';

class ProdutividadeApi extends Api {
  async montarGraficoFaturasPorMes (filter) {
    try {
      const urlProdutividadeFaturasPorMes = Configuracao.getConfiguracao().urlProdutividadeFaturasPorMes;
      const response = await this.fetch(urlProdutividadeFaturasPorMes, 'POST', filter, { 'content-type': 'application/json' });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async montarGraficoGuiasPorMes (filter) {
    try {
      const urlProdutividadeGuiasPorMes = Configuracao.getConfiguracao().urlProdutividadeGuiasPorMes;
      const response = await this.fetch(urlProdutividadeGuiasPorMes, 'POST', filter, { 'content-type': 'application/json' });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async montarGraficoElementosPorMes (filter) {
    try {
      const urlProdutividadeElementosPorMes = Configuracao.getConfiguracao().urlProdutividadeElementosPorMes;
      const response = await this.fetch(urlProdutividadeElementosPorMes, 'POST', filter, { 'content-type': 'application/json' });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default ProdutividadeApi;
